import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicTextField from './DynamicTextField';
import DynamicDropdownField from './DynamicDropdownField';
import DynamicDateField from './DynamicDateField';
import DynamicFileField from './DynamicFileField';
import DynamicCheckboxField from './DynamicCheckboxField';
import DynamicRadioField from './DynamicRadioField';
import DynamicTextareaField from './DynamicTextareaField';
import DynamicNumberField from './DynamicNumberField';
import DynamicEmailField from './DynamicEmailField';
import DynamicPhoneField from './DynamicPhoneField';
import DynamicUrlField from './DynamicUrlField';

export interface FieldDefinition {
  id: number;
  key: string;
  type: string;
  label: string;
  label_ar: string;
  placeholder: string;
  placeholder_ar: string;
  required: boolean;
  validation: any;
  options?: {
    value: string;
    label: string;
    label_ar: string;
  }[];
}

interface FieldRendererProps {
  field: FieldDefinition;
  value: any;
  onChange: (fieldKey: string, value: any) => void;
  error?: string;
  disabled?: boolean;
}

const FieldRenderer: React.FC<FieldRendererProps> = ({
  field,
  value,
  onChange,
  error,
  disabled = false
}) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const commonProps = {
    field,
    value,
    onChange,
    error,
    disabled,
    isArabic
  };

  const renderField = () => {
    switch (field.type) {
      case 'text':
        return <DynamicTextField {...commonProps} />;
      case 'textarea':
        return <DynamicTextareaField {...commonProps} />;
      case 'number':
        return <DynamicNumberField {...commonProps} />;
      case 'email':
        return <DynamicEmailField {...commonProps} />;
      case 'phone':
        return <DynamicPhoneField {...commonProps} />;
      case 'url':
        return <DynamicUrlField {...commonProps} />;
      case 'date':
        return <DynamicDateField {...commonProps} />;
      case 'dropdown':
        return <DynamicDropdownField {...commonProps} />;
      case 'checkbox':
        return <DynamicCheckboxField {...commonProps} />;
      case 'radio':
        return <DynamicRadioField {...commonProps} />;
      case 'file':
        return <DynamicFileField {...commonProps} />;
      default:        return <DynamicTextField {...commonProps} />;
    }
  };

  return (
    <div className="mb-4">
      {renderField()}
    </div>
  );
};

export default FieldRenderer;